import CrudReducer from './crudReducer';

const cr = new CrudReducer('todo_item_question');

const reducer = cr.Reducer;

export default reducer;
